import { render, staticRenderFns } from "./OrdersDeleteDoubleConfirmationDialog.vue?vue&type=template&id=0f6b7d7c&scoped=true"
import script from "./OrdersDeleteDoubleConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./OrdersDeleteDoubleConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./OrdersDeleteDoubleConfirmationDialog.vue?vue&type=style&index=0&id=0f6b7d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b7d7c",
  null
  
)

export default component.exports